export function variantMatchesSupplyTypes(
    supplyType: string | null | undefined,
    supplyTypes?: string[]
): boolean {
    if (!supplyTypes?.length) {
        return true;
    }

    const normalized = new Set(supplyTypes.map((t) => t.toLowerCase()));
    const type = (supplyType ?? "").toLowerCase();
    const isPreOrder = type === "pre-order";

    if (!isPreOrder && normalized.has("stock")) {
        return true;
    }
    if (isPreOrder && normalized.has("pre-order")) {
        return true;
    }

    return false;
}

export function filterVariantsBySupplyTypes<
    T extends { supplyType?: string | null; pricing?: { supplyType?: string | null } },
>(variants: T[], supplyTypes?: string[]): T[] {
    if (!supplyTypes?.length) {
        return variants;
    }

    return variants.filter((variant) =>
        variantMatchesSupplyTypes(
            variant.supplyType ?? variant.pricing?.supplyType,
            supplyTypes
        )
    );
}
